.full-width {
  width: 100%;
}
